module.exports = __webpack_public_path__ + "img/selected1-min.eb6fab0e.png";